import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IDifferenceStock,
  IDifferenceStockInitialState,
} from "./distributorDifferenceStockModel";
import {
  createDifferenceStock,
  deleteDifferenceStock,
  getAllDistributorRetailerMarginRates,
  getAllDifferenceStocks,
  getDifferenceStockByID,
  updateDifferenceStock,
  getDistributorCurrentStock,
} from "./services/distributorDifferenceStock.services";

const initialState: IDifferenceStockInitialState = {
  loading: false,
  error: "",
  DifferenceStockID: null,
  DifferenceStockList: [],
  MarginRateList: [],
  CurrentSockList: {
    accountid: null,
    account_name: "",
    date: "",
    item_data: [],
  },
  DifferenceStockDetail: {
    accountid: null,
    date: "",
    disributor_stock_list: [],
  },
};

const distributorDifferenceStockSlice = createSlice({
  name: "distributorDifferenceStock",
  initialState,
  reducers: {
    clearDifferenceStockDetails: (state) => {
      state.DifferenceStockDetail = initialState.DifferenceStockDetail;
    },
    setDifferenceStockID: (state, action) => {
      state.DifferenceStockID = action.payload;
    },
    clearDifferenceStockID: (state) => {
      state.DifferenceStockID = initialState.DifferenceStockID;
    },
    clearMarginRateList: (state) => {
      state.MarginRateList = initialState.MarginRateList;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllDifferenceStocks.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllDifferenceStocks.fulfilled,
      (state, action: PayloadAction<IDifferenceStock[]>) => {
        state.loading = false;
        state.DifferenceStockList = action.payload || [];
      }
    );
    builder.addCase(getAllDifferenceStocks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.DifferenceStockList = [];
    });

    builder.addCase(createDifferenceStock.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createDifferenceStock.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createDifferenceStock.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateDifferenceStock.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateDifferenceStock.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateDifferenceStock.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteDifferenceStock.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteDifferenceStock.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteDifferenceStock.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getDifferenceStockByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getDifferenceStockByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.DifferenceStockDetail = action.payload;
    });
    builder.addCase(getDifferenceStockByID.rejected, (state, action) => {
      state.loading = false;
      state.DifferenceStockDetail = initialState.DifferenceStockDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllDistributorRetailerMarginRates.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllDistributorRetailerMarginRates.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.MarginRateList = action.payload || [];
      }
    );
    builder.addCase(
      getAllDistributorRetailerMarginRates.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.MarginRateList = [];
      }
    );

    builder.addCase(getDistributorCurrentStock.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getDistributorCurrentStock.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.CurrentSockList = action.payload;
      }
    );
    builder.addCase(getDistributorCurrentStock.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CurrentSockList = initialState.CurrentSockList;
    });
  },
});

export const {
  clearDifferenceStockDetails,
  clearDifferenceStockID,
  clearMarginRateList,
  setDifferenceStockID,
} = distributorDifferenceStockSlice.actions;
export default distributorDifferenceStockSlice.reducer;
